import { Divider, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";

import { ReportHeader } from "./subComponents/reportHeader";

import DailySalesReport from "./DailySalesReports";
import CategorySalesReport from "./CategorySalesReport";
import DetailedSalesReport from "./DetailedSalesReport";
import ItemSalesReport from "./ItemSalesReport";
import PurchasePaymentReport from "./PurchasePaymentReport";
import PurchaseGstReport from "./PurchaseGstReport";
import CategoryExpenseReport from "./CategoryExpenseReport";
import ProfitExpenseReport from "./ProfitExpenseReport";
import PurchaseReport from "./PurchaseReport";

export const Reports: React.FC<any> = React.memo(
    (props) => {
        const { control } = useForm();
        const tabsData: any[] = [
            { label: "Daily Sales Summary", content: <DailySalesReport /> },
            {
                label: "Detailed Sales Report",
                content: <DetailedSalesReport />
            },

            { label: "Item Sales Report", content: <ItemSalesReport /> },
            { label: "Category Sales Report", content: <CategorySalesReport /> },
            { label: "Purchase Report", content: <PurchaseReport /> },
            { label: "Purchase Payment Report", content: <PurchasePaymentReport /> },
            { label: "Purchase Gst Report", content: <PurchaseGstReport /> },
            { label: "Category Expense Report", content: <CategoryExpenseReport /> },
            { label: "Profit Expense Report", content: <ProfitExpenseReport /> },
        ];

        return (
            <>
                {" "}
                <Grid item container spacing={2}>
                    <Grid item sm={12} xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
                <ReportHeader
                    title="Sales Report"
                    type="light"
                    color="primary"
                    isBackButton={true}
                    url="/dashboard"
                />
                <Grid container spacing={2}>
                    <Grid item xs={12} >
                        <WSTabs
                        
                            id="adasd"
                            control={control}
                            name="tabs"
                            tabs={tabsData}
                            justifyTabs="flex-start"
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
);
